module.exports = __webpack_public_path__ + "img/yidongIcon.28f7b507.png";